import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle,
          Img       } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./CoronaVirus.css"

class CoronaVirus extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {
   
    Promise.all([ asyncgetWeather() ]).then( response => {
      const weather = response[0];
        this.setState({
          jerusalemWeather  : weather.jerusalem.temperature,
          telAvivWeather    : weather.telaviv.temperature,
          waterTemp         : weather.telaviv.water_temp
        })
    });
  
    window.addEventListener("resize", this.updateDimensions);
  }
  
  render(){
    return(
      <div className="page align-left page-Corona-virus">
        <Menu />
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
            
            <div className="container">
             
             

            
              <p>Tijdens deze uitdagende tijden staan we in Israël naast alle Nederlanders. Onze gedachten en gebeden gaan naar jullie uit en samen hopen we op een mooie, betere toekomst.</p>
            
          {/* <h1>ISRAËL REISADVIES &amp; VEILIGHEIDSINFORMATIE</h1>*/}
          
          <h2 className="ac-pink">ACTUELE INFORMATIE VOOR TOERISTEN NAAR ISRAËL WAT BETREFT HET CORONAVIRUS (COVID-19):</h2>
          
         {/*  <h2 className="ac-pink ac-margin-top-1 ac-bigger">Israël kondigt verdere verlichtingsmaatregelen aan</h2>
          
          
          <p>Per 1 juni heeft het Israëlische ministerie van Volksgezondheid een nieuwe reeks verlichtingsmaatregelen aangekondigd, waaronder de opening van restaurants, toeristische attracties en hotels.</p>
          <p>De stranden zijn op 20 mei geopend.</p>
          <p>Vanaf 27 mei 2020 mogen restaurants, bars, pubs en clubs open, onder voorbehoud van enkele beperkingen. Vrijetijds- en toeristische attracties zoals hotels, musea en zwembaden mogen ook worden geopend, onder voorbehoud van enkele beperkingen.</p>
          <p>Het ministerie van Volksgezondheid heeft ook afgesproken om de passagierscapaciteit voor bussen en taxi's vanaf 8 juni te vergroten en de treinactiviteit te hervatten.</p>
          <p>Entertainment en vrijetijdsactiviteiten worden hervat op 14 juni, inclusief evenementenlocaties, concerten, theaters, film-, kunst- en culturele evenementen, onder voorbehoud van enkele beperkingen.</p>
          <p>In de toerismesector hebben verschillende landen aangekondigd dat ze hun grenzen openstellen voor Israëlische burgers: Griekenland, Oostenrijk, Montenegro, Georgië en Cyprus (vanaf 9 juni).</p>
          <p>Internationale luchtvaartmaatschappijen zoals Delta Airlines, British Airways, Air Canada, Wizz Air, Ryanair, Lufthansa, Turkish Airlines, Alitalia, Ukrainian International hebben aangekondigd dat ze deze zomer commerciële vluchten van en naar Israël willen hervatten.</p>*/}
          
          
          <h2 className="ac-pink ac-margin-top-1 ac-bigger">Toeristen die naar <br className="show-on-mobile"/>Israël willen reizen:</h2>
          
          <p>Momenteel en tot nader order zullen alle niet-inwoners van Israël, vanuit de hele wereld de toegang tot het land worden geweigerd. In uitzonderlijke gevallen kun je goedkeuring aanvragen bij het ministerie van Buitenlandse Zaken, mits je kunt aantonen dat je na aankomst 14 dagen in thuisisolatie kunt gaan.</p> 
          
          <h2 className="ac-pink ac-margin-top-1 ac-bigger">Belangrijk!</h2>
          
          <ul>
              <li>Als je verzocht wordt in thuisisolatie te gaan, <strong className="ac-pink">geef dit dan door aan het ministerie van Gezondheid: <a href="https://www.govforms.gov.il" target="_blank">www.govforms.gov.il/</a></strong></li>
              <li>Als je koorts hebt van 38°C of hoger, hoest, moeite hebt met ademen of andere ademhalingssymptomen, <strong className="ac-pink">ga dan direct in thuisisolatie en bel de 101 MDA Emergency Services Hotline voor medisch advies.</strong></li>
              <li>Het is absoluut verboden klinieken of ziekenhuizen binnen te gaan als je één van bovenstaande symptomen hebt!</li>
          </ul>
          
          <h2 className="ac-pink ac-margin-top-1 ac-bigger">Algemene richtlijnen voor iedereen die in Israël verblijft:</h2>
          
          <ul>
              <li>Voor de meest actuele informatie over het coronavirus in Israël, ga naar de <a href="https://govextra.gov.il/ministry-of-health/corona/corona-virus-en/" target="_blank">website</a> van het ministerie van Gezondheid.</li>
              <li>De Israëlische overheid houdt de verspreiding scherp in de gaten en heeft tijdelijke maatregelen afgekondigd, waaronder grensbeperkingen voor reizigers van over de hele wereld.</li>
          </ul>
          
          <h2 className="ac-pink ac-margin-top-1 ac-bigger">Veelgestelde Vragen</h2>
          
          
          <ol className="ac-padding-start-1">
            <li>
              <strong className="ac-pink">Ik ben toerist in Israël en bang dat ik misschien COVID-19 heb. Waar moet ik heen?</strong><br/>
              Als je koorts hebt van 38°C of hoger, hoest, moeite hebt met ademen of andere luchtwegsymptomen, ga je direct in thuisisolatie en bel je de 101 MDA Emergency Services Hotline voor medisch advies. <strong class="ac-pink">Ga niet naar een kliniek of eerstehulppost.</strong>          
            </li>
            <li>
              <strong className="ac-pink">Wanneer is Israël weer open voor bezoekers?</strong><br/>
            </li>
          </ol>
          
          <p>Op dit moment is er nog geen datum bekend wanneer Israël weer bezoekers toelaat.</p>




          <Img desktopImg={"infection.jpg"} />

          </div>

          
        <Footer />
      </div>
    )
    }

}



export default CoronaVirus


// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirusNL.js